import { render } from "./FeaturedCategories.vue?vue&type=template&id=7efe8205&scoped=true"
import script from "./FeaturedCategories.vue?vue&type=script&lang=js"
export * from "./FeaturedCategories.vue?vue&type=script&lang=js"

import "./FeaturedCategories.vue?vue&type=style&index=0&id=7efe8205&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efe8205"]])

export default __exports__